import Image from '@interfaces/media.interface'

export interface Purpose {
  text: string
  images: Image[]
  followersInstagram: number
  categories: any[]
}

export interface WhoDoes {
  text: string
  images: Image[]
}

export interface From {
  username: string
}

export interface Comment {
  id: string
  text: string
  timestamp: Date
  from: From
  replies: any[]
}

export interface Communication {
  textPerfect: string
  imagesPerfect: Image[]
  textZeal: string
  imagesZeal: Image[]
  textComments: string
  imagesComments: Image[]
  comments: Comment[]
}

export interface InsightsInstagram {
  engagementRate: number
  likes: number
  postsReach: number
  postsImpressions: number
  comments: number
  saves: number
  postsCount: number
  storiesCount: number
  daysPosts: number
  daysStories: number
  storiesReach: number
  storiesImpressions: number
  storiesReplies: number
  storiesTapBacks: number
  storiesEngagementRate: number
}

export interface Click {
  _id: string
  hit_id: string
  unique_click: boolean
  username: string
  profile_id: number
  mediakit_id: string
  user_agent: string
  fingerprint: string
  createdAt: Date
  updatedAt: Date
  __v: number
  weekOfYear: number
  date: string
}

export interface Clicks {
  clicks: Click[]
  startDate: Date
  endDate: Date
  totalClicks: number
  week: number
}

export interface DatasetClicks {
  label: string
  data: Array<number>
}
export interface ChartDatasetClicks {
  labels: string[]
  datasets: DatasetClicks
}

export interface ChartClicks {
  clicks: ChartDatasetClicks
}
export interface Analytics {
  chart: ChartClicks
  insightsInstagram: InsightsInstagram
  images: Image[]
  clicks: Clicks[]
  totalClicks: number
  totalClicks28Days: number
}

export interface FollowersCount {
  startDate: Date
  endDate: Date
  countDays: number
  count: number
  week: number
}

export interface AudiencePerGender {
  key: string
  percentage: number
}

export interface Data {
  MALE: number
  FEMALE: number
  UNISEX: number
}

export interface AudienceAgePerGender {
  key: string
  data: Data
}

export interface AudienceCity {
  key: string
  percentage: number
}

export interface TargetAudience {
  followersInstagram: number
  followersCount: FollowersCount[]
  audiencePerGender: AudiencePerGender[]
  audienceAgePerGender: AudienceAgePerGender[]
  audienceCities: AudienceCity[]
  postsPerWeek: any[]
}

export interface Profile {
  id: string
  picture: string
  username: string
}

export interface Brand {
  profile: Profile
  image: Image
}

export interface WhoAnnounced {
  brands: Brand[]
}

export default class MediaKit {
  _id?: string
  username?: string
  profileId?: string
  name?: string
  enabled?: boolean
  purpose?: Purpose
  insightsUpdateAt?: Date
  updatedAt?: Date
  whoDoes?: WhoDoes
  communication?: Communication
  analytics?: Analytics
  targetAudience?: TargetAudience
  whoAnnounced?: WhoAnnounced

  constructor(mediakit: MediaKit) {
    this._id = mediakit._id
    this.username = mediakit.username
    this.profileId = mediakit.profileId
    this.name = mediakit.name
    this.enabled = mediakit.enabled
    this.purpose = mediakit.purpose
    this.insightsUpdateAt = mediakit.insightsUpdateAt
    this.updatedAt = mediakit.updatedAt
    this.whoDoes = mediakit.whoDoes
    this.communication = mediakit.communication
    this.analytics = mediakit.analytics
    this.targetAudience = mediakit.targetAudience
    this.whoAnnounced = mediakit.whoAnnounced
  }

  toPatchPayload?(): any {
    delete this?.purpose?.followersInstagram
    delete this?.purpose?.categories

    return {
      purpose: this?.purpose,
      whoDoes: this?.whoDoes,
      communication: this?.communication,
      whoAnnounced: this?.whoAnnounced,
      enabled: this?.enabled,
      name: this?.name,
      profileId: this?.profileId,
    }
  }
}
